import { render } from "./ImageCover.vue?vue&type=template&id=0ca0b34c"
import script from "./ImageCover.vue?vue&type=script&lang=js"
export * from "./ImageCover.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/jeronimo/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__